import React, { Component, useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { loadPublicEventListing } from "../actions";
import { commafy, compose, getConfig, titleCase } from "../utils/helpers";
import withTable from "./tables/withTable";
import DataTable from "./tables/DataTable";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import { dataPlaceholder } from "../utils/constants";


class PublicRunlist extends Component {
    static propTypes = {
        params: PropTypes.object,
        publicEventListing: PropTypes.array,
    }

    constructor(props) {
        super(props);
        const mpName = getConfig('name');
        
        this.state = {
            isLoading: true,
            mpName,
            publicEventId: props.params.publicEventId,
            title: "Public Runlist",
            vehicleData: [],
        }
    }

    componentDidMount() {
        const mpId = getConfig('marketplaceId');
        const {publicEventId} = this.state
        this.props.loadPublicEventListing(mpId, publicEventId);
    }

    componentDidUpdate() {
      if (this.state.isLoading) {
        try {
          if (this.props.publicEventListing?.publicEvent?.items?.length) {
            const {items, name} = this.props.publicEventListing?.publicEvent;
            const vehicleData = [...items];
            this.setState({
              isLoading: false,
              title: name,
              vehicleData,
            })
          }
        } catch (loadListingError) {
          console.error(
            "Error occurred on loading of event listing",
            loadListingError?.message || loadListingError
          );
        }
      }
    }

    /**
     *  Data        | Year      | Make       | Model       | Exterior Color | Lot #     | Odometer  | Trim    | VIN    | CR Grade | CR Link
     *  ----------  |  -------  | ---------- | ----------- | -------------  | --------- | --------  | ------- | ------ | ------- | --------
     * **Field**    | `row.year`| `row.make` | `row.model` | `row.extColor` | `row.lot` | `mileage` |   `trim` | `vin` | `grade` | `crLink`
     * **Sortable** | `true`    | `true`     | `true`      |                | `true`    | `true`    | `true`  | `true` |         |   
     * 
     * **Notes**:
     *  - The column `*ClassName` fields are for styling in Print view, which is currently disabled for this component.
     */
    makeColumns() {
      return this.props.makeColumns([
        // Lot Number
        "lotNumber",
        { // Year
            accessor: row =>
              row.year || row.vehicleYear || row.yr || dataPlaceholder,
            className: 'datatable-column__year',
            filterable: false,
            headerClassName: 'datatable-column__year',
            Header: 'Year',
            id: 'year',
        },
        { // Make
            accessor: row => row.make || dataPlaceholder,
            className: 'datatable-column__make',
            filterable: false,
            headerClassName: 'datatable-column__make',
            Header: 'Make',
            id: 'make',
        },
        { // Model
            accessor: row => row.model || dataPlaceholder,
            className: 'datatable-column__model',
            filterable: false,
            headerClassName: 'datatable-column__model',
            Header: 'Model',
            id: 'model',
        },
        {  // Exterior Color
            accessor: row =>
              titleCase(row.extColor) || titleCase(row.exteriorColor) || dataPlaceholder,
            className: 'datatable-column__vehicledata',
            filterable: false,
            headerClassName: 'datatable-column__vehicledata',
            Header: 'Color',
            id: 'extColor',
            sortable: false,
        },
        {  // Odometer
            accessor: row =>
              commafy(row.mileage) || commafy(row.odometer) || dataPlaceholder,
            className: 'datatable-column__mileage',
            filterable: false,
            headerClassName: 'datatable-column__mileage',
            Header: `Odometer`,
            id: 'mileage',
        },
        { // Trim
          accessor: row => row.trim || row.series || dataPlaceholder,
          className: 'datatable-column__model',
          filterable: false,
          headerClassName: 'datatable-column__model',
          Header: 'Trim',
          id: 'trim',
          sortable: true,
        },
        { // VIN
          accessor: row =>
            row.vin || row.vIN || row.VIN || dataPlaceholder,
          className: 'datatable-column__vin',
          filterable: false,
          headerClassName: 'datatable-column__vin',
          Header: 'VIN',
          id: 'vin',
        },
        // CR Grade -- uses 'crGrade'
        "grade", 
        // CR Link
        this.makeCrLinkColumn()
      ]);
    }

    makeCrLinkColumn() {
        return {
          Header: 'CR Link',
          id: 'crLink',
          headerStyle: { background: 'none' },
          sortable: false,
          filterable: false,
          Cell: row => {
            const crUrl = row.original.crLink;
            return (
              <div >
                {crUrl
                  ?(
                    <div>
                      <a target={"_blank"} href={crUrl} >
                        {"Condition Report  "}
                        <Icon name={"external alternate"} />
                      </a>
                    </div>
                  )
                  : ("")
                }
              </div>
            );
          },
        }
    }

    renderDivider() {
      return (
        <hr style={{
          borderColor: '#E5E5E5',
          width: '100%',
          alignSelf: 'center',
          marginTop: 15,
          marginBottom: 15,
        }} />
      )
    }

    renderPageHeader() {
      const {mpName='', title} = this.state
      return (
        <div style={{
          alignItems: 'center', 
          display: 'flex', 
          flexDirection: 'row', 
          flexGrow: 2,
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          padding: '15px',
          width: '100%',
        }}>
          <h4 style={{
            margin: '5px 0px 0px',
            padding: '5px 0px 0px 20px',
            textAlign: 'left', 
            width: '100%'
          }}
          >{mpName}</h4>
          <h3 style={{
            margin: '10px auto 15px',
            minWidth: '350px',
            textAlign: 'center', 
          }}
          >{title}</h3>
          <a style={{
            display: 'flex', 
            gap: 4, 
            margin: '0 auto',
            textAlign: 'right',
          }} 
          href={"/login"} 
          >
            {"Back to Login  "}
            <Icon size={"large"} name={"sign in alternate"} />
          </a>
        </div>
      )
    }

    render() {
      const {vehicleData: data, isLoading, title} = this.state;

      return (
        <div
          className="st-container shadow padding background-white padding"
          style={{minHeight: '100vh', width: '100%'}}
        >
          {this.renderPageHeader()}
          {this.renderDivider()}
          <DataTable
            columns={this.makeColumns()}
            customPageSizes={[20, 40, 80, 100]}
            data={data}
            loading={isLoading}
            selectedData={[]}
            title={title}
          />
        </div>
      )
    }
}

const mapStateToProps = state => {
  const {publicEventListing} = state.entities;
  return {publicEventListing};
}

export default compose(
  withTable,
  connect(mapStateToProps, {
    loadPublicEventListing,
  })
)(PublicRunlist);